<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-users-list'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Users</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-users-list'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addUser">Add User</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add User</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-input
            type="text"
            name="first name"
            class="field"
            v-model="contact.first_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter first name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('first name')"
          >{{ errors.first('first name') }}</div>
          <primary-input
            type="text"
            name="user name"
            v-model="contact.user_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('user name')}"
            placeholder="Enter username"
          />
          <div class="help is-danger" v-if="errors.has('user name')">{{ errors.first('user name') }}</div>
          <primary-input
            type="password"
            name="password"
            v-model="contact.passwd"
            v-validate="'required'"
            ref="password"
            :class="{'input': true, 'is-danger': errors.has('password')}"
            placeholder="********"
          />
          <div v-if="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</div>
          <primary-select
            type="text"
            name="status"
            v-model="contact.status"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('status')}"
            placeholder="Choose status"
          >
            <option value selected></option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </primary-select>
          <div v-if="errors.has('status')" class="help is-danger">{{ errors.first('status') }}</div>
        </div>
        <div class="col">
          <primary-input
            type="text"
            name="last name"
            v-model="contact.last_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('last name')}"
            placeholder="Enter last name"
          />
          <div v-if="errors.has('last name')" class="help is-danger">{{ errors.first('last name') }}</div>
          <primary-input
            name="email"
            type="text"
            v-model="contact.email"
            v-validate="'required|email'"
            :class="{'input': true, 'is-danger': errors.has('email')}"
            placeholder="Enter email"
          />
          <div v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</div>
          <primary-input
            type="password"
            name="re-enter password"
            v-validate="'required|confirmed:password'"
            data-vv-as="password"
            v-model="checkPassowrd"
            :class="{'input': true, 'is-danger': errors.has('re-enter password')}"
            placeholder="********"
          />
          <div
            class="help is-danger"
            v-if="errors.has('re-enter password')"
          >{{ errors.first('re-enter password') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
  },
  data: () => ({
    contactError: null,
    role: ["Admin", "Normal"],
    contact: {
      user_name: null,
      email: null,
      last_name: null,
      passwd: null,
      first_name: null,
      rank: null,
      logo_file_uuid: null,
      status: null,
      //company_uuid: null,
    },
    file: null,
    checkPassowrd: null,
  }),
  created() {},
  methods: {
    fileAdded(file) {
      if (file.accepted) {
        this.file = file;
      }
    },
    fileRemoved() {
      this.file = null;
      this.user.logo_file_uuid = null;
    },
    uploadPhoto: async function () {
      let data = new FormData();

      data.append("file", this.file);
      data.append("belongs_to", "vendor.logo");
      data.append("public", true);

      return await this.$store.dispatch("UploadFile", data);
    },
    addUser: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        if (this.file) {
          let res = await this.uploadPhoto();
          this.contact.logo_file_uuid = res.object_uuid;
        } else {
          delete this.contact.logo_file_uuid;
        }
        this.contact.rank =
          this.contact.rank === "Admin" ? "Premium" : "Default";
        await this.$store.dispatch("AddUser", {
          user: this.contact,
        });

        this.$snotify.success("User have been added.", {
          timeout: 6000,
        });

        this.$router.push({ name: "reseller-users-list" });
      } catch (err) {
        if (err.errors) {
          this.contactError = err.errors[0].invoice
            ? err.errors[0].invoice
            : null;
          setTimeout(() => {
            this.contactError = null;
          }, 6000);
        } else if (err.response) {
          this.$snotify.error(
            err.response.data.errors
              ? err.response.data.errors
              : err.response.data.error.message,
            { timeout: 6000 }
          );
        } else {
          this.$snotify.error(err, { timeout: 6000 });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.col > div {
  width: 95%;
}
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }

    .primary-select-wrapper {
      width: 95%;
    }

    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .upload-photo,
        #dropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
              border-radius: 50px;
            }
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

